import { Fragment, type ReactNode } from 'react'

/**
 * Numbers inside a sentence in JetBrains Mono, tabular (design/system README rule 8: "JetBrains Mono for
 * every number"): runs of digits with their separators (9, 1,250, 13.5, 2026) become `.tabular`
 * spans; the words stay in the sans face. For texts built from i18n.ts with numbers in them.
 */
export function withMono(text: string): ReactNode {
  const parts = text.split(/(\d[\d.,:  ]*\d|\d)/)
  if (parts.length === 1) return text
  return parts.map((p, i) => (i % 2 ? <span key={i} className="tabular font-mono">{p}</span> : <Fragment key={i}>{p}</Fragment>))
}
